/* istanbul ignore file */
import { ARTIFACT_ID } from 'domain/shared/artifact';
import { ArtifactUploaderInput, ArtifactUploaderInputProps } from 'domain/shared/artifact/input';

const FeedbackAttachmentUploaderInput = (props: ArtifactUploaderInputProps) => {
  return <ArtifactUploaderInput {...props} artifactTypeId={ARTIFACT_ID.FEEDBACK_ATTACHMENT} />;
};

export default FeedbackAttachmentUploaderInput;
